import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_INTERACTION} from '../../metamodel/Concept';

export default class TechnologyInteractionNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_INTERACTION;
	}
}
